const baseAmazonPath = 'music.amazon.com';
const baseEmbeddedPath = 'https://music.amazon.com.br/embed/';
const createEmbeddedLink = (link) => {
    const path = link.split(baseAmazonPath)[1].split('/');
    const finalPath = path[path.length - 1];
    return `${baseEmbeddedPath}${finalPath}`;
};
export const amazonMusic = {
    category: 'AUDIO',
    isSatisfied: (link) => link.includes(baseAmazonPath),
    getPlayerExecutionProps: (link) => ({
        link: createEmbeddedLink(link),
        allowProps: 'encrypted-media',
        height: 450,
        responsive: true,
    }),
};
